(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Header turns white after scrolling (homepage overlay) */
  var header = $('[data-header]');
  if (header && header.classList.contains('header--overlay')) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 24); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Menu drawer */
  var drawer = $('[data-drawer]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { setDrawer(true); }
    else if (e.target.closest('[data-drawer-close]')) { setDrawer(false); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  /* Hearts (saved on this device only) */
  var saved = [];
  try { saved = JSON.parse(localStorage.getItem('ytp-hearts') || '[]'); } catch (e) {}
  $$('[data-heart]').forEach(function (b) {
    if (saved.indexOf(b.dataset.heart) > -1) b.classList.add('is-on');
    b.addEventListener('click', function () {
      var h = b.dataset.heart, i = saved.indexOf(h);
      if (i > -1) saved.splice(i, 1); else saved.push(h);
      $$('[data-heart="' + h + '"]').forEach(function (x) { x.classList.toggle('is-on', i === -1); });
      try { localStorage.setItem('ytp-hearts', JSON.stringify(saved)); } catch (e) {}
    });
  });

  /* Newsletter: add Man / Woman / Both as a tag */
  $$('.news__form').forEach(function (f) {
    f.addEventListener('submit', function () {
      var tags = $('[name="contact[tags]"]', f);
      var pref = $('[name="pref"]:checked', f);
      if (tags) tags.value = tags.dataset.baseTags + (pref ? ',pref-' + pref.value : '');
    });
  });

  /* Collection sort */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* Cart quantity: auto update */
  $$('[data-qty]').forEach(function (q) {
    q.addEventListener('change', function () { q.form.submit(); });
  });

  /* Product page: variant picker */
  var sec = $('[data-product-section]');
  if (sec) {
    var form = $('.pdp__form', sec);
    var vEl = $('[data-variants]', sec);
    if (form && vEl) {
      var variants = JSON.parse(vEl.textContent);
      var currency = JSON.parse($('[data-money-currency]', sec).textContent);
      var fmt = function (c) {
        try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(c / 100); }
        catch (e) { return (c / 100).toFixed(2); }
      };
      var idEl = $('[data-variant-id]', form), priceEl = $('[data-price]', sec),
          cmpEl = $('[data-compare]', sec), atc = $('[data-atc]', form), atcText = $('[data-atc-text]', form);
      var update = function () {
        var vals = [];
        $$('[data-option]', form).forEach(function (fs, i) {
          var sel = $('select', fs);
          var c = sel ? null : $('input:checked', fs);
          vals[i] = sel ? sel.value : (c ? c.value : null);
          var l = $('[data-opt-label]', fs);
          if (l && c) l.textContent = c.value;
        });
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return o === vals[i]; });
        })[0];
        if (!v) { atc.disabled = true; atcText.textContent = 'Unavailable'; return; }
        idEl.value = v.id;
        priceEl.textContent = fmt(v.price);
        if (cmpEl) {
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          cmpEl.hidden = !onSale;
          if (onSale) cmpEl.textContent = fmt(v.compare_at_price);
        }
        atc.disabled = !v.available;
        atcText.textContent = v.available ? (atc.dataset.preorder === 'true' ? 'Pre-order' : 'Add to cart') : 'Sold out';
        try { history.replaceState(null, '', '?variant=' + v.id); } catch (e) {}
        if (v.featured_media && window.matchMedia('(max-width: 989px)').matches) {
          var slide = $('[data-media-id="' + v.featured_media.id + '"]', sec);
          if (slide && slide.parentNode) slide.parentNode.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      };
      form.addEventListener('change', update);
      /* ?color=Cream in the link pre-selects that color */
      var want = new URLSearchParams(window.location.search).get('color');
      if (want) {
        $$('select[data-opt-select] option', form).forEach(function (o) {
          if (o.value.toLowerCase() === want.toLowerCase()) { o.selected = true; }
        });
        update();
      }
      /* switch photo when a color has a matching photo (alt text contains the color) */
    }
  }
})();
